const common = {
  back: 'رجوع',
  edit: 'تعديل',
  remove: 'إزالة',
  error: 'حدث خطأ. يرجى المحاولة مرة أخرى.',
  badges: {
    falIndividual: 'فرد (رخصة صفقات 24)',
  },
  common: {
    loading: 'جارٍ التحميل...',
    signIn: 'تسجيل الدخول',
  },
  // Generic UI labels used in multiple places (e.g. table headers).
  name: 'الاسم',
  email: 'البريد الإلكتروني',
  role: 'الدور',
  you: 'أنت',
  tableView: 'عرض الجدول',
  cardView: 'عرض البطاقات',
  signin_to_save_favorites: 'سجّل الدخول لحفظ مفضلاتك',
  brand: {
    name: 'صفقات 24',
    tagline: 'منصتك العقارية الموثوقة',
  },
  navigation: {
    home: 'الرئيسية',
    search: 'ابحث عن عقار',
    consultation: 'حجز استشارة',
    create: 'أضف عقاراً',
    subscriptions: 'الاشتراكات',
    contact: 'تواصل معنا',
    trustedBrokers: 'مسوّق ووسيط عقاري',
    clientRequests: 'طلبات العقارات',
    dashboard: 'لوحة التحكم',
    listProperty: 'أضف عقارك',
    postRequest: 'أضف طلبك',
    profile: 'حسابي',
    settings: 'الإعدادات',
    services: 'خدماتنا',
    myComplaints: 'شكاواي',
    companyDashboard: 'لوحة تحكم الشركة',
    teamManagement: 'إدارة الفريق',
    registerCompany: 'سجل شركتك',
    enquiries: 'الاستفسارات',
    openMenu: 'فتح قائمة التنقل',
    closeMenu: 'إغلاق قائمة التنقل',
    sidebar: {
      guest: 'زائر',
      navigation: 'التنقل',
      account: 'الحساب',
      quickActions: 'إجراءات سريعة',
      accountSettings: 'إعدادات الحساب',
      myAds: 'إعلاناتي',
      licenses: 'التراخيص',
      myRequests: 'طلباتي',
      bookingHistory: 'سجل الحجوزات',
      addProperty: 'إضافة عقار',
      bookConsultation: 'حجز استشارة',
      subscriptions: 'الاشتراكات',
      favorites: 'المفضلة',
      trustedBrokers: 'مسوّق ووسيط عقاري',
      submitRequest: 'تقديم طلب عقار',
      brokerRequests: 'طلبات العملاء',
      authorizeProperty: 'تفويض عقار',
      aboutUs: 'من نحن',
      complaints: 'تقديم شكوى',
      dashboard: 'لوحة التحكم',
      services: 'الخدمات',
      myListings: 'عقاراتي',
      postRequest: 'أضف طلبك',
    },
  },
  auth: {
    join: 'انضم الآن',
    signIn: 'تسجيل الدخول',
    signUp: 'إنشاء حساب',
    signOut: 'تسجيل الخروج',
    settings: 'إعدادات الحساب',
    loadingTitle: 'نحضّر تجربتك المخصصة...',
    loadingSubtitle: 'يرجى الانتظار بينما نجهز أحدث القوائم العقارية.',
    // عناوين النماذج والصفحات
    signInTitle: 'تسجيل الدخول',
    signUpTitle: 'إنشاء حساب',
    welcomeBack: 'مرحباً بعودتك',
    signInSubtitle: 'سجّل الدخول إلى حسابك في صفقات 24',
    createAccountTitle: 'أنشئ حسابك',
    createAccountSubtitle: 'انضم إلى صفقات 24 للعثور على عقارك المثالي',
    resetPasswordTitle: 'إعادة تعيين كلمة المرور',
    resetPasswordSubtitle: 'أدخل عنوان بريدك الإلكتروني وسنرسل لك رابطاً لإعادة تعيين كلمة المرور.',
    // تسميات النماذج
    firstName: 'الاسم الأول',
    lastName: 'اسم العائلة',
    email: 'البريد الإلكتروني',
    password: 'كلمة المرور',
    confirmPassword: 'تأكيد كلمة المرور',
    required: '*',
    // العناصر النائبة
    enterFirstName: 'أدخل اسمك الأول',
    enterLastName: 'أدخل اسم عائلتك',
    enterEmail: 'أدخل بريدك الإلكتروني',
    enterPassword: 'أدخل كلمة المرور',
    createPassword: 'أنشئ كلمة مرور قوية',
    confirmYourPassword: 'أكّد كلمة المرور',
    // الأزرار والإجراءات
    signingIn: 'جارٍ تسجيل الدخول...',
    creatingAccount: 'جارٍ إنشاء الحساب...',
    sending: 'جارٍ الإرسال...',
    sendResetLink: 'إرسال رابط إعادة التعيين',
    cancel: 'إلغاء',
    rememberMe: 'تذكرني',
    forgotPassword: 'هل نسيت كلمة المرور؟',
    backToHome: 'العودة إلى الصفحة الرئيسية',
    // الروابط والتبديلات
    noAccount: 'ليس لديك حساب؟',
    hasAccount: 'هل لديك حساب بالفعل؟',
    signUpFree: 'سجّل مجاناً',
    signInHere: 'سجّل الدخول هنا',
    showPassword: 'إظهار كلمة المرور',
    hidePassword: 'إخفاء كلمة المرور',
    closeModal: 'إغلاق نافذة المصادقة',
    // نص المساعدة
    passwordRequirements: 'يجب أن تكون 8 أحرف على الأقل مع حرف كبير وحرف صغير ورقم',
    agreeToTerms: 'أوافق على',
    termsOfService: 'شروط الخدمة',
    and: 'و',
    privacyPolicy: 'سياسة الخصوصية',
    byCreatingAccount: 'بإنشاء حساب، فإنك توافق على',
    // رسائل النجاح
    signInSuccess: 'تم تسجيل الدخول بنجاح! مرحباً بعودتك.',
    signUpSuccess: 'تم إنشاء الحساب بنجاح! يرجى التحقق من بريدك الإلكتروني للتحقق من حسابك.',
    signUpSuccessRedirect: 'تم إنشاء الحساب بنجاح! يرجى التحقق من بريدك الإلكتروني للتحقق من حسابك قبل تسجيل الدخول.',
    verifyEmailMessage: 'يرجى التحقق من بريدك الإلكتروني والتحقق من حسابك للمتابعة.',
    passwordResetSent: 'تم إرسال بريد إعادة تعيين كلمة المرور! يرجى التحقق من بريدك الوارد.',
    redirecting: 'جارٍ إعادة التوجيه...',
    // رسائل الخطأ
    emailRequired: 'البريد الإلكتروني مطلوب',
    emailInvalid: 'يرجى إدخال عنوان بريد إلكتروني صالح',
    emailTooLong: 'يجب أن يكون البريد الإلكتروني أقل من 100 حرف',
    passwordRequired: 'كلمة المرور مطلوبة',
    passwordTooShort: 'يجب أن تكون كلمة المرور 8 أحرف على الأقل',
    passwordTooLong: 'يجب أن تكون كلمة المرور أقل من 128 حرفاً',
    passwordWeak: 'يجب أن تحتوي كلمة المرور على حرف كبير واحد على الأقل وحرف صغير ورقم',
    confirmPasswordRequired: 'يرجى تأكيد كلمة المرور',
    passwordsMismatch: 'كلمات المرور غير متطابقة',
    firstNameRequired: 'الاسم الأول مطلوب',
    firstNameTooShort: 'يجب أن يكون الاسم الأول حرفين على الأقل',
    firstNameTooLong: 'يجب أن يكون الاسم الأول أقل من 50 حرفاً',
    firstNameInvalid: 'يمكن أن يحتوي الاسم الأول فقط على أحرف (عربية أو إنجليزية) ومسافات وواصلات وفواصل عليا',
    lastNameRequired: 'اسم العائلة مطلوب',
    lastNameTooShort: 'يجب أن يكون اسم العائلة حرفين على الأقل',
    lastNameTooLong: 'يجب أن يكون اسم العائلة أقل من 50 حرفاً',
    lastNameInvalid: 'يمكن أن يحتوي اسم العائلة فقط على أحرف (عربية أو إنجليزية) ومسافات وواصلات وفواصل عليا',
    termsRequired: 'يجب الموافقة على شروط الخدمة وسياسة الخصوصية',
    emailForReset: 'يرجى إدخال عنوان بريدك الإلكتروني أولاً',
    // رسائل خطأ API
    invalidCredentials: 'بريد إلكتروني أو كلمة مرور غير صحيحة. يرجى التحقق من بياناتك.',
    emailNotConfirmed: 'يرجى التحقق من بريدك الإلكتروني وتأكيد حسابك قبل تسجيل الدخول.',
    userAlreadyExists: 'يوجد حساب مسجل بهذا البريد الإلكتروني بالفعل. يرجى تسجيل الدخول.',
    accountDeleted: 'تم حذف هذا الحساب. يمكنك إنشاء حساب جديد بهذا البريد الإلكتروني.',
    accountSuspended: 'تم تعليق حسابك. يرجى التواصل مع الدعم للمساعدة.',
    accountInactive: 'حسابك غير نشط. يرجى التحقق من بريدك الإلكتروني أو التواصل مع الدعم.',
    passwordTooWeak: 'يجب أن تكون كلمة المرور 6 أحرف على الأقل.',
    tooManyRequests: 'محاولات كثيرة جداً. يرجى الانتظار لحظة قبل المحاولة مرة أخرى.',
    passwordResetFailed: 'فشل إرسال بريد إعادة تعيين كلمة المرور. يرجى المحاولة مرة أخرى.',
    unexpectedError: 'حدث خطأ غير متوقع. يرجى المحاولة مرة أخرى.',
    networkError: 'تعذر الاتصال بالخادم. يرجى التحقق من اتصالك بالإنترنت والمحاولة مرة أخرى.',
    // التحقق من البريد الإلكتروني
    verifyEmailTitle: 'تحقق من بريدك الإلكتروني',
    verificationCodeSent: 'لقد أرسلنا رمز التحقق إلى {{email}}',
    verificationInstructions: 'الرجاء إدخال الرمز المكون من 6 أرقام الذي أرسلناه إلى {{email}}',
    verificationCode: 'رمز التحقق',
    enterSixDigitCode: 'أدخل الرمز المكون من 6 أرقام من بريدك الإلكتروني',
    verifying: 'جارٍ التحقق...',
    verifyAndCreateAccount: 'تحقق وأنشئ الحساب',
    didntReceiveCode: 'لم تستلم الرمز؟',
    resendCode: 'إعادة إرسال الرمز',
    resendIn: 'إعادة الإرسال خلال {{seconds}} ثانية',
    backToSignUp: 'العودة للتسجيل',
    verificationSuccess: 'تم التحقق من البريد الإلكتروني بنجاح! مرحباً بك في صفقات 24.',
    otpResent: 'تم إرسال رمز تحقق جديد إلى بريدك الإلكتروني.',
    resendFailed: 'فشل إعادة إرسال رمز التحقق. يرجى المحاولة مرة أخرى.',
    invalidOtpCode: 'الرجاء إدخال رمز صالح مكون من 6 أرقام',
    invalidOrExpiredOtp: 'رمز التحقق غير صالح أو منتهي الصلاحية. يرجى المحاولة مرة أخرى أو طلب رمز جديد.',
    registrationExpired: 'انتهت صلاحية جلسة التسجيل. يرجى التسجيل مرة أخرى.',
    // Two-factor authentication (TOTP)
    twoFactorTitle: 'المصادقة الثنائية',
    twoFactorSubtitle: 'أدخل الرمز المكوّن من 6 أرقام من تطبيق المصادقة',
    backupCodeTitle: 'أدخل رمز النسخ الاحتياطي',
    backupCodeSubtitle: 'أدخل أحد رموز النسخ الاحتياطي المكوّنة من 10 أحرف',
    verify: 'تحقّق',
    useBackupCode: 'استخدم رمز نسخ احتياطي بدلاً من ذلك',
    useAuthenticatorApp: 'استخدم تطبيق المصادقة بدلاً من ذلك',
    backToSignIn: 'العودة إلى تسجيل الدخول',
    backupCode: 'رمز النسخ الاحتياطي',
    invalidTotpCode: 'الرمز غير صحيح أو انتهت صلاحيته. حاول مرة أخرى.',
    // Password reset page (/reset-password)
    newPasswordSubtitle: 'أنشئ كلمة مرور قوية جديدة لحسابك.',
    newPassword: 'كلمة المرور الجديدة',
    updatePassword: 'تحديث كلمة المرور',
    updatingPassword: 'جارٍ تحديث كلمة المرور...',
    passwordUpdatedTitle: 'تم تحديث كلمة المرور',
    passwordUpdatedSubtitle: 'سنقوم بتحويلك إلى صفحة تسجيل الدخول…',
    passwordResetSuccess: 'تم تغيير كلمة المرور. يمكنك الآن تسجيل الدخول.',
    passwordUpdateFailed: 'تعذّر تحديث كلمة المرور. يرجى المحاولة مرة أخرى.',
    resetLinkInvalidSubtitle: 'هذا الرابط غير صالح أو منتهي الصلاحية.',
    resetLinkInvalidLong: 'الرابط غير مكتمل أو منتهي. يُرجى طلب رابط جديد من صفحة تسجيل الدخول.',
    requestNewLink: 'اطلب رابطاً جديداً',
    rememberedPassword: 'تذكرت كلمة المرور؟',
  },
  language: {
    label: 'اللغة',
    english: 'English',
    arabic: 'العربية',
  },
  currency: {
    code: 'SAR',
    short: 'ر.س',
    name: 'الريال السعودي',
  },
  units: {
    sqm: 'م²',
    sqft: 'قدم²',
    month: 'شهر',
    year: 'سنة',
  },
  footer: {
    description:
      'صفقات 24 - منصتك الموثوقة لأفضل المساكن والإيجارات الفاخرة مع تقديم استشارات مصممة خصيصاً لكل عميل.',
    quickLinksTitle: 'روابط سريعة',
    servicesTitle: 'خدمات',
    companyTitle: 'الشركة',
    contactTitle: 'تواصل',
    quickLinks: {
      home: 'الرئيسية',
      search: 'ابحث عن عقار',
      map: 'الخريطة',
      brokersMap: 'خريطة الوسطاء',
      trustedBrokers: 'مسوّق ووسيط عقاري',
      marketInsights: 'مؤشرات السوق',
      consultation: 'احجز استشارة',
      contact: 'تواصل معنا',
    },
    serviceLinks: {
      listProperty: 'أضف عقارك',
      membership: 'باقات الاشتراك',
      addons: 'الإضافات',
      bundles: 'الباقات',
      coins: 'المحفظة والنقاط',
    },
    companyLinks: {
      about: 'من نحن',
      contact: 'تواصل معنا',
      requests: 'اطلب عقاراً',
      complaints: 'تقديم شكوى',
      terms: 'الشروط والأحكام',
      privacy: 'سياسة الخصوصية',
    },
    services: {
      sales: 'مبيعات المنازل الفاخرة',
      management: 'إدارة الممتلكات',
      advisory: 'الاستشارات الاستثمارية',
      corporate: 'حلول التأجير للشركات',
    },
    address: 'جدة',
    phone: '+966 50 560 8271',
    email: 'info@safaqat24.sa',
    liveChat: 'الدعم المباشر',
    notice:
      'صفقات 24 مرخّصة من الهيئة العامة للعقار في المملكة العربية السعودية. جميع الحقوق محفوظة.',
    copyright: 'جميع الحقوق محفوظة.',
    privacy: 'سياسة الخصوصية',
    terms: 'الشروط والأحكام',
  },
  theme: {
    label: 'المظهر',
    toggle: 'تبديل المظهر',
    purple: 'بنفسجي',
    earthy: 'ترابي',
  },
  brokerMap: {
    title: 'الوسطاء في أنحاء المملكة',
    subtitle: 'استكشف الوسطاء والشركات حسب مقرّهم وأماكن إعلاناتهم.',
    searchPlaceholder: 'ابحث عن وسيط…',
    verifiedOnly: 'الموثّقون فقط',
    rankBy: 'ترتيب حسب',
    topBrokers: 'الأكثر نشاطاً',
    navLink: 'خريطة الوسطاء',
    viewOnMap: 'عرض على الخريطة',
    type: { all: 'الكل', individual: 'أفراد', company: 'شركات', developer: 'المطورون العقاريون' },
    metric: { listings: 'الإعلانات', engagement: 'التفاعل' },
    mode: { reach: 'الانتشار', listings: 'الإعلانات' },
  },
  // صفحة الصفقات الخاصة (/special-deals) المخصّصة للمشتركين. الصفحة تقرأ هذه المفاتيح
  // عبر t('special.*')؛ قبل إضافة هذا القسم كانت تعود إلى النص الإنجليزي الافتراضي في
  // كلا اللغتين (فتظهر بالإنجليزية حتى في الوضع العربي).
  special: {
    title: 'صفقات خاصة',
    subtitle: 'قوائم مميّزة حصرية متاحة لمشتركي صفقات 24.',
    lockedTitle: 'ميزة حصرية للمشتركين',
    lockedSub: 'الصفقات الخاصة حصرية لمشتركي صفقات 24. اشترِك للوصول إليها.',
    lockedGuest: 'سجّل الدخول واشترك لفتح العروض الحصرية على صفقات 24.',
    subscribe: 'عرض باقات الاشتراك',
    empty: 'لا توجد صفقات خاصة متاحة حالياً. عُد للتحقّق قريباً.',
    loadError: 'تعذّر تحميل الصفقات الخاصة.',
  },
  // شارات الحالة في components/ui/StatusChip.tsx، تقرؤها عبر t('status.<TOKEN>').
  // قبل إضافة هذا القسم كانت الشارة تعرض النص الإنجليزي حتى في الوضع العربي.
  // الكلمات منسوخة من مواضعها الحالية (engage.statuses، verification، addons، home).
  status: {
    VERIFIED: 'موثّق',
    VERIFYING: 'قيد التحقق',
    DECLARED: 'قيد الانتظار',
    EXPIRING_SOON: 'ينتهي قريباً',
    EXPIRED: 'منتهي',
    SUSPENDED: 'موقوف',
    REJECTED: 'مرفوض',
    REQUESTED: 'تم الطلب',
    QUOTED: 'تم إرسال العرض',
    ACCEPTED: 'مقبول',
    IN_PROGRESS: 'قيد التنفيذ',
    DELIVERED: 'تم التسليم',
    COMPLETED: 'مكتمل',
    CANCELLED: 'ملغى',
    PLANNING: 'قيد التخطيط',
    UNDER_CONSTRUCTION: 'قيد الإنشاء',
    READY: 'جاهز',
    SOLD_OUT: 'مباع بالكامل',
  },
  // صفحة «طوّر حسابك» (/account/professional): كانت تعرض النص الإنجليزي الافتراضي
  // في الواجهة العربية. أسماء الأدوار منسوخة من roleCatalog وقائمة «سجل معنا».
  pro: {
    title: 'طوّر حسابك',
    subtitle: 'أضف لنفسك دوراً مهنياً مرخّصاً، أو سجّل شركة تملكها. يُوثَّق كل دور برخصته.',
    yourRoles: 'أدوارك المهنية',
    addRole: 'أضف دوراً مهنياً',
    selectRole: 'اختر الدور…',
    scopeUser: 'لي (فرد)',
    scopeCompany: 'لشركتي',
    displayName: 'الاسم الظاهر (اختياري)',
    licenseNumber: 'رقم الرخصة (للتوثيق الآن)',
    addRoleBtn: 'أضف الدور',
    registerCompany: 'سجّل شركة',
    registerCompanyHint: 'أنشئ شركة تملكها، ثم أضف أنشطتها المرخّصة (الوساطة والتطوير وغيرها).',
    companyName: 'اسم الشركة',
    companyPhone: 'رقم هاتف الشركة (اختياري)',
    registerCompanyBtn: 'سجّل الشركة',
    disabled: 'الأدوار المهنية غير مفعّلة بعد.',
    loadError: 'تعذّر تحميل أدوارك المهنية.',
    dupRole: 'لديك هذا الدور بالفعل.',
    addError: 'تعذّرت إضافة الدور.',
    hasCompany: 'أنت مرتبط بشركة بالفعل.',
    companyError: 'تعذّر تسجيل الشركة.',
    type: {
      BROKER: 'مسوّق ووسيط عقاري',
      DEVELOPER: 'مطوّر عقاري',
      INVESTOR: 'مستثمر',
      CONSULTANT: 'مستشار عقاري',
      ANALYST: 'محلل عقاري',
      APPRAISER: 'مقيّم عقاري',
      PROPERTY_MANAGEMENT: 'إدارة أملاك',
      FACILITIES_MANAGEMENT: 'إدارة مرافق',
    },
  },
};

export default common;

